<template>
  <div class="relative w-full">
    <el-image
      class="w-full h-full"
      :src="backgroundImage"
      fit="cover"
      style="object-position: center"
    ></el-image>
  </div>
</template>

<script>
export default {
  name: "news-module1",
  data() {
    return {
      backgroundImage: `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/news/module1/sample2.png`,
    };
  },
  methods: {
    // 动态加载图片，根据文件名选择合适的格式
    getImage(imageName) {
      const formats = ["png", "jpg", "jpeg", "webp"];
      for (let format of formats) {
        try {
          return require(`@/assets/images/News/module1/${imageName}.${format}`);
        } catch (e) {
          continue;
        }
      }
      return "";
    },
  },
};
</script>

<style scoped>
</style>